/** API client for the meter-link evidence worklists (spec 2026-09-02 section 6
 *  Phase 5.2). The per-feeder counts ride on the data-quality rollup; this
 *  module pages the three worklists. Auth header is attached automatically by
 *  the shared `get` helper. */

import { get } from './client.ts'
import type {
  EvidencePage, MeterLinkOpinions, PoleDisagreement, PoleWithoutTransformer,
  SecondaryDisagreement,
} from '../types/linkEvidence.ts'

export interface EvidenceParams {
  feeder_id?: number
  tier?: 'auto' | 'flagged'
  /** Omit for every row; set to the page's far_threshold_m for the "> N m" filter. */
  min_distance_m?: number
  skip?: number
  limit?: number
}

function qs(params: EvidenceParams): string {
  const q = new URLSearchParams()
  if (params.feeder_id != null) q.set('feeder_id', String(params.feeder_id))
  if (params.tier) q.set('tier', params.tier)
  if (params.min_distance_m != null) q.set('min_distance_m', String(params.min_distance_m))
  if (params.skip != null) q.set('skip', String(params.skip))
  if (params.limit != null) q.set('limit', String(params.limit))
  const s = q.toString()
  return s ? `?${s}` : ''
}

export function getSecondaryDisagreements(params: EvidenceParams = {}) {
  return get<EvidencePage<SecondaryDisagreement>>(`/engineering/link-evidence/secondary-disagreements${qs(params)}`)
}
export function getPoleDisagreements(params: EvidenceParams = {}) {
  return get<EvidencePage<PoleDisagreement>>(`/engineering/link-evidence/pole-disagreements${qs(params)}`)
}
export function getPolesWithoutTransformer(params: EvidenceParams = {}) {
  return get<EvidencePage<PoleWithoutTransformer>>(`/engineering/link-evidence/poles-without-transformer${qs(params)}`)
}

/** The three opinions about one meter's transformer, for the meter detail
 *  panel's "Link evidence" block (spec 2026-09-02 section 6 Phase 5.4). This
 *  one hangs off the meter, not the engineering worklists. */
export function getMeterLinkOpinions(id: number) {
  return get<MeterLinkOpinions>(`/meters/${id}/link-opinions`)
}
